import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class SensorTypeTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.manufacturer = null;
		/** @type {string} */
		this.modelId = null;
		/** @type {number} */
		this.maxSamplingRate = null;
		/** @type {number} */
		this.externalId = null;
	}

	/**
	 * @typedef {Object} _SensorTypeTableDtoProps
	 * @property {string} manufacturer
	 * @property {string} modelId
	 * @property {number} maxSamplingRate
	 * @property {number} externalId
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _SensorTypeTableDtoProps} SensorTypeTableDtoProps
	 */
	/**
	 *
	 * @param {SensorTypeTableDtoProps} props
	 * @returns {SensorTypeTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.manufacturer = props.manufacturer;
		this.modelId = props.modelId;
		this.maxSamplingRate = props.maxSamplingRate;
		this.externalId = props.externalId;
		return this;
	}
}
